import React, { useEffect, useState } from "react";
import BrandWordmark from "./BrandWordmark";

// Rotates for as long as App.js holds this screen up (SPLASH_MIN_MS). Three
// lines at ~1s each fills that window with visible change instead of a
// single line sitting still.
const LOADING_LINES = [
  "Loading your leagues",
  "Checking this week's scores",
  "Setting up your lineup",
];

function SplashScreen() {
  const [lineIndex, setLineIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setLineIndex((i) => (i + 1) % LOADING_LINES.length);
    }, 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div className="theme-auto" style={{ position: 'fixed', inset: 0,
      backgroundColor: 'var(--color-bg-card)',
    }}>
      {/* Pinned to the true viewport center, matching where the native
          launch image sits (it has nothing below it to push it off-center).
          The React splash used to center a flex column that also held the
          dots and text, which dragged the wordmark upward the moment it
          replaced the native image, reading as a second, different screen
          rather than one continuous one. */}
      <div style={{
        position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
      }}>
        <BrandWordmark width={250} shimmer />
      </div>

      <div style={{
        position: 'absolute', top: 'calc(50% + 110px)', left: '50%', transform: 'translateX(-50%)',
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 14,
      }}>
        <div style={{ display: 'flex', gap: 6 }}>
          {[0, 1, 2].map(i => (
            <div key={i} style={{
              width: 8, height: 8, borderRadius: '50%', backgroundColor: 'var(--color-brand)',
              animation: `pulse 1.2s ease-in-out ${i * 0.2}s infinite`,
              opacity: 0.7,
            }} />
          ))}
        </div>

        <span
          key={lineIndex}
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: 'var(--color-text-faint)',
            animation: 'splash-line-fade 0.4s ease',
            whiteSpace: 'nowrap',
          }}
        >
          {LOADING_LINES[lineIndex]}
        </span>
      </div>

      <style>{`
        @keyframes pulse { 0%, 100% { transform: scale(1); opacity: 0.4; } 50% { transform: scale(1.4); opacity: 1; } }
        @keyframes splash-line-fade { from { opacity: 0; transform: translateY(2px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>
    </div>
  );
}

export default SplashScreen;
